// Main JavaScript file
console.log('WordPress theme loaded');

// Add your JavaScript code here
document.addEventListener('DOMContentLoaded', function() {
    // Initialize your JavaScript
});